import { normalizeMimeType } from './mimeType'

const OFFICE_VIEWER_EMBED_URL = 'https://view.officeapps.live.com/op/embed.aspx'

// Mime types rendered through the Microsoft Office Online viewer.
// Uploadcare reports OOXML files (.docx/.xlsx/.pptx) with their full OOXML mime type,
// while files stored on s3 get the legacy type from MimeTypeEnums — both must be listed.
// Macro-enabled files (.pptm/.docm) are deliberately absent: the embed viewer rejects them as "file not found".
export const OFFICE_MIME_TYPES = Object.freeze([
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation'
])

export function isOfficeMimeType (mimeType) {
  return OFFICE_MIME_TYPES.includes(normalizeMimeType(mimeType))
}

// The source must be encoded, otherwise query params of signed URLs leak into the viewer's own query string
export function officeViewerUrl (fileUrl) {
  return `${OFFICE_VIEWER_EMBED_URL}?src=${encodeURIComponent(fileUrl || '')}`
}
